//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../GeometricUtilities/GeometricUtilities.BooleanToolBuilder.js";
import "../no/SelectDatumPlaneList.js";
import "../no/SelectFaceList.js";
import "../no/SelectBodyList.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"AngularAxis",1,"Axis",0],[1,"BooleanTool",0,"GeometricUtilities.BooleanToolBuilder",0],[0,"CloneObject",0,"Tooling.CloneObject",0],[0,"CopyInstance",1,0],[0,"DefNum",1,0],[0,"ElectrodeBlankBuilder",1,"TaggedObject",0],[0,"ManipulatorMatrix",1,0],[0,"ManipulatorOrigin",1,0],[1,"MirrorPlane",0,"SelectDatumPlaneList",0],[0,"Rename",1,0],[1,"SelToFace",0,"SelectFaceList",0],[0,"SelType",1,0],[1,"SelectElectrode",0,"SelectBodyList",0],[0,"SelectFromCsys",1,"CoordinateSystem",0],[1,"SelectFromFace",0,"SelectFaceList",0],[0,"SelectToCsys",1,"CoordinateSystem",0],[0,"TransformMotionType",1,0]],[[["blankPartName"],"SetBlankPartName",{},1,0],[["copyType","eleBody","fromface","toface"],"CopyElectrode",{R_:{newPart:"NXObject"}},4,0],[["blankBuilderTag","partTag","count","paraNames"],"UpdateParameterData",{R_:{modelPath:''}},2,0],[["installationMethod"],"SetInstallationMethod",{},1,0]],[]];
SPLM.Tooling.ElectrodeCopyBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.ElectrodeCopyBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.ElectrodeCopyBuilder.Copy = Object.freeze({
    "Transform" : "Transform", "Mirror" : "Mirror"});

SPLM.Tooling.ElectrodeCopyBuilder.TransformMotionTypes = Object.freeze({
    "FaceToFace" : "FaceToFace", "CSYSToCSYS" : "CSYSToCSYS", "Rotation" : "Rotation", "Dynamic" : "Dynamic"});

SPLM.Tooling.ElectrodeCopyBuilder.CloneMethod = Object.freeze({
    "UseLogFile" : "UseLogFile", "InternalClone" : "InternalClone", "PartRename" : "PartRename", "SaveAs" : "SaveAs"});

export default SPLM;